var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accordion"},[_c('h3',{on:{"click":function($event){$event.preventDefault();_vm.open = !_vm.open}}},[_vm._t("title"),_vm._v(" "),_c('i',{class:`far fa-angle-${_vm.open ? 'up' : 'down'}`})],2),_vm._v(" "),_c('TransitionExpand',[(_vm.open)?_vm._t("body"):_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }